import React, { cache, useEffect, useState } from 'react'
import EmailIcon from '@mui/icons-material/Email';
import ContactsIcon from '@mui/icons-material/Contacts';
import Api from '../../Api.js';
import user from "../../assets/img/userbig.png";
import { useDispatch, useSelector } from "react-redux"
import _ from "lodash";
import Messages from './Messages.js';
import {toast} from "react-toastify";
import { messageList, messageUpdate } from '../../store/actions/messages.js';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
export default function Chat({ visible }) {
    const [chats, setChats] = useState([])
    const [isChat, setIsChat] = useState(true)
    const [createGroup, setCreateGroup] = useState(false)
    const login = useSelector((state) => state.manager.employee);
    const [room, setRoom] = useState(0)
    const [chatWith, setChatWith] = useState('')
    const dispatch = useDispatch()
    const messages = useSelector(state => state.message.messageList)
    const [allContacts, setAllContacts] = useState([]);    // original list
    const [contacts, setContacts] = useState(allContacts)
    const [selectedMember, setSelectedMember] = useState([])
    const [groupName, setGroupName] = useState("")
    const [groupNameSee, setGroupNameSee] = useState(false)
    useEffect(() => {
        setContacts(allContacts)
        setChats(messages)
    }, [allContacts, messages])
    const handleSearch = (search) => {
        if (isChat) {
            setChats(
                messages.filter(c => {
                    const use = contacts.find(l =>
                        c?.members?.includes(l?.user?.email) &&
                        l?.user?.email !== login?.user?.email
                    );
                    if (!use) return false; // skip if no matching contact
                    const fullName = `${use?.user?.first_name || ""} ${use?.user?.last_name || ""}`.toLowerCase();
                    return fullName.includes(search.toLowerCase());
                })
            );
        } else {
            setContacts(
                allContacts.filter(c => {
                    const fullName = `${c?.user?.first_name || ""} ${c?.user?.last_name || ""}`.toLowerCase();
                    return fullName.includes(search.toLowerCase());
                })
            );
        }
    };
    useEffect(() => {
        (async () => {
            const { data } = await Api.getContact()
            const { data: list } = await Api.getRooms()
            setAllContacts([...data.accountants, ...data.manager,])
            dispatch(messageList(list))
        })()
    }, [])

    const handleChatWith = (data) => {
        setRoom(data.room)
        setChatWith(data.name)
        dispatch(messageUpdate(data.room))

    }
    const handleSelectMember = (memberId, checked) => {
        setSelectedMember(prev =>
            checked
                ? [...prev, memberId] // add if checked
                : prev.filter(id => id !== memberId) // remove if unchecked
        );
    };
    const handleCreateRoom = async (params) => {
        try {
            const { data } = await Api.createRoom(params)
            const { data: list } = await Api.getRooms()
            dispatch(messageList(list))

            handleChatWith({ room: data.id, name: params.name })
        } catch (e) {
            console.log(e);

        }
    }

    const handleCreateGroup = () => {
        if(selectedMember.length <= 1 ){
            toast.error("Ընտրեք 2 կամ ավելի անդամ")
        }
        if (!groupName) {
            setGroupNameSee(true)
            return
        }
        handleCreateRoom({
            name:groupName,
            is_group: true,
            members: [...selectedMember,login?.user_id]
        })

        setGroupName("")
        setGroupNameSee(false)
        setSelectedMember([])
    }


    const handleChat = (data) => {
        setRoom(0)
        setIsChat(data)
    }
    return (
        <>
            {messages?.reduce((sum, room) => sum + room.unread_count, 0) ? <p className='unread'>{messages?.reduce((sum, room) => sum + room.unread_count, 0)}</p> : null}
            <div className='chatBlock' style={!visible ? { display: "none" } : {}}>
                <div className='chatHeader'>{room ? chatWith : isChat ? "Չատեր" : "Կոնտակտներ"}</div>
                <div className='chatData'>
                    <div style={{ padding: 10, display: "flex", alignItems: 'center' }}>
                        <input placeholder='Որոնել' style={{ width: "100%", borderRadius: 13, padding: "4px 10px" }} onChange={(ev) => handleSearch(ev.target.value)} />
                        <span onClick={() => setCreateGroup(prev => !prev)}><GroupAddIcon style={{ marginLeft: 5 }} /></span>
                    </div>
                    <div className='d-flex wrap'>
                        {selectedMember.map(l => <div key={l} className='chatGroupSelect'>{allContacts.find(c => c.user_id === l)?.user.first_name} {allContacts.find(c => c.user_id === l)?.user.last_name}</div>)}
                    </div>
                    {room ? <Messages room={room} /> :
                        createGroup ?
                            contacts.map((c, i) => {
                                if (login?.user_id !== c?.user_id && c) {
                                    return (
                                        <div key={i} className='chatRow'>
                                            <input
                                                type="checkbox"
                                                checked={selectedMember.includes(c.user_id)} // control checked state
                                                onChange={(e) => handleSelectMember(c.user_id, e.target.checked)}
                                            />
                                            <img alt='' src={c?.image || user} />
                                            <p>{c?.user?.first_name} {c?.user?.last_name}</p>
                                        </div>
                                    )
                                }
                            }) :
                            isChat ? chats.length ? chats.map((c, i) => {
                                let use = c.is_group?{user:{first_name:c.name,last_name:""}}:allContacts.find(l => c?.members?.includes(l?.user?.email) && l?.user?.email !== login?.user?.email)

                                return (
                                    <div key={i} onClick={() => handleChatWith({ room: c.id, name: `${use.user.first_name} ${use.user.last_name}` })} className='chatRow'>
                                        <img alt='' src={use?.image || user} />
                                        <p>{use?.user?.first_name} {use?.user?.last_name}</p>
                                        {c.unread_count ? <span className="unread_message" style={{ marginLeft: "auto" }}>{c.unread_count}</span> : null}
                                    </div>
                                )
                            }) : <div className="nodata">Դեռևս զրույցներ չկան</div> : contacts.length ? contacts.map((c, i) => {
                                if (login?.user_id !== c?.user_id && c) {
                                    return (
                                        <div key={i} onClick={() => handleCreateRoom({
                                            name: (c?.user?.first_name + " " + c?.user?.last_name) || null,
                                            is_group: false,
                                            members: [c?.user_id, login?.user_id]
                                        })} className='chatRow'>
                                            <img alt='' src={c?.image || user} />
                                            <p>{c?.user?.first_name} {c?.user?.last_name}</p>
                                        </div>
                                    )
                                }
                            }) : <div className="nodata">Կոնտակտներ չկան</div>}
                </div>
                <div className='chatFooter'>
                    <p onClick={() => handleChat(true)}>
                        <EmailIcon />
                        <span>Չատեր</span>
                    </p>
                    <p onClick={() => handleChat(false)}><ContactsIcon /><span>Կոնտակտներ</span></p>

                </div>
            </div >
            {visible && selectedMember.length?<span onClick={handleCreateGroup} className='selectButton'><DoneOutlineIcon /> </span>:null}
            {groupNameSee?<div className="chat-modal-overlay" onClick={() => {setGroupNameSee(false); setGroupName("")}}>
                <div onClick={(e) => e.stopPropagation()} className="chat-modal-box">
                    <input className='chat-name-input' value={groupName} onChange={(ev)=>setGroupName(ev.target.value)}/>
                    <button class="blue-button" onClick={handleCreateGroup}>Հաստատել</button>
                </div>
            </div>:null}

        </>
    )
}
